export default {
  AuthResponseDialog__BUTTON_GROUP_ARIA_NEXT: "Next",
  AuthResponseDialog__BUTTON_GROUP_ARIA_PREVIOUS: "Previous",
};
